<template>
  <div class="loading">
    <div  class="loading-step">{{messageStep}}</div>
  </div>
</template> 
<script>
import { useStore } from 'vuex';
import interceptor from '@/plugins/interceptor';
import { onMounted, ref} from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const messageStep = ref('Cargando')

    onMounted(async () => {
      try {
        //get userData
        //get viewParams
        messageStep.value="Iniciando sesión"
        await store.dispatch('forgeAuth_loadData');
        //get rukyhash
        //auth Ruky
        messageStep.value="Accediendo a Ruky"
        await store.dispatch('forgeAuth_authRuky');
        //redirect ToView
        messageStep.value="Preparando datos"
        const routeNav = interceptor.getParameterByName("navTo",window.location.href);
        router.push(routeNav);
      } catch (error) {
        store.dispatch('notifications_create', { text: t(`notifications.generic`) });
      }
    });

    return {
      messageStep
    }
  }
}
</script>
<style lang="scss" scoped>
.loading-step {
    margin: 20px;
    font-size: 36px;
    font-family: sans-serif;
}

.loading-step:after {
  display: inline-block;
  animation: dotty steps(1,end) 2s infinite;
  content: '';
}

@keyframes dotty {
  0%   { content: '.'; }
  33%  { content: '..'; }
  66%  { content: '...'; }
  
}


.loading {
      position: absolute;
    width: 100px;
    height: 50px;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -25px;
    text-align: center;
    &-main {
      font-size: 24px;
    }
    &-step{
      font-size: 20px;
      color: #666;
      white-space: nowrap;
    }
}
</style>